import Modal from "@mui/material/Modal";
import EsfirusButtonNative from "@components/ui/Button/EsfirusButtonNative";
import EsfirusSelect from "@components/ui/Select/EsfirusSelect";
import { useState } from "react";
import { useSelector } from "@services/hooks/redux-hooks";
import EsfirusTextInput from "@components/ui/Text-input/EsfirusTextInput";

interface ModalChangeStatusProps {
  open: boolean;
  onClose: () => void;
  aviso: any;
  onClick: Function;
  isLoading: boolean;
}

export const ModalChangeStatus = ({ open, onClose, aviso, onClick, isLoading }: ModalChangeStatusProps) => {
  const noticeStatuses = useSelector(state => state.notices.listStatuses)
  const [newStatus, setNewStatus] = useState<string>("")
  const [comments, setComments] = useState<string>("")
  const [sendMailEmployee, setSendMailEmployee] = useState<boolean>(false)
  const [sendAlertEmployee, setSendAlertEmployee] = useState<boolean>(false)
  const [sendMailContacts, setSendMailContacts] = useState<boolean>(false)

  // Render.
  const currentStatus = noticeStatuses.find(status => status.status === aviso?.status)
  const options = noticeStatuses.filter(status => status.status !== aviso?.status).map(status => ({
    value: status.status,
    label: status.description
  }))

  return (
    <Modal
      open={open}
      onClose={() => isLoading ? null : onClose()}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className="new-confirm-modal">
        <div className="header">
          <h5 className="text-center">
            Cambiar estado del aviso
          </h5>
        </div>

        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 36, padding: 32 }}>
          {isLoading ? <>
            <div style={{ textAlign: "center", fontSize: 20 }}>
              Cambiando estado del aviso ...
            </div>
          </> : <>
            <div style={{ textAlign: "center", fontSize: 20 }}>
              El estado del aviso actual es "<b>{currentStatus?.description ?? "-"}</b>"
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: 16, fontSize: 20, maxWidth: 400, width: 400 }}>
              <div>
                <label>Nuevo estado</label>
                <EsfirusSelect
                  options={options}
                  change={(e: any) => setNewStatus(e)}
                  value={newStatus}
                  placeholder="Seleccionar..."
                />
              </div>
              <div>
                <label>Comentarios</label>
                <EsfirusTextInput
                  fullWidth
                  value={comments}
                  onChange={(e: any) => setComments(e.target.value)}
                  placeholder="Escribe comentarios sobre los cambios ..."
                />
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                <label style={{ margin: 0 }} className="containerCheckbox">
                  <input type="checkbox"
                    checked={sendMailEmployee}
                    onChange={(e) => setSendMailEmployee(e.target.checked)} />
                  <span className="checkmark" />
                  Enviar correo al empleado
                </label>
                <label style={{ margin: 0 }} className="containerCheckbox">
                  <input type="checkbox"
                    checked={sendAlertEmployee}
                    onChange={(e) => setSendAlertEmployee(e.target.checked)} />
                  <span className="checkmark" />
                  Enviar alerta al empleado
                </label>
                <label style={{ margin: 0 }} className="containerCheckbox">
                  <input type="checkbox"
                    checked={sendMailContacts}
                    onChange={(e) => setSendMailContacts(e.target.checked)} />
                  <span className="checkmark" />
                  Enviar correo a los contactos
                </label>
              </div>
            </div>
          </>}
          <div style={{ display: "flex", justifyContent: "center", gap: 16 }}>
            <EsfirusButtonNative
              click={() => onClick({ newStatus, comments, sendMailEmployee, sendAlertEmployee, sendMailContacts })}
              label={"Confirmar"}
              className={"secondary"}
              disabled={!newStatus || isLoading}
            />
            <EsfirusButtonNative
              click={() => onClose()}
              label={"Cancelar"}
              disabled={isLoading}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
}